import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import {
  Router,
  UrlTree,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';

import { SnSessionService } from '../services';

@Injectable()
export class SnAuthorizedGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly _router: Router,
    private readonly _sessionService: SnSessionService,
  ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | UrlTree {
    if (route.fragment && route.fragment.includes('token=')) {
      const token = route.fragment.replace('token=', '');
      this._sessionService.setToken(token);
      this._sessionService.setAblyToken('');
      this._sessionService.setAzureWebPubSubUrl('');
      this._sessionService.setCjisApprovedKey();
      return this._router.createUrlTree(['/map']);
    }

    return this._sessionService.check().pipe(
      map((isActivated) => {
        if (!isActivated) {
          return this._getRedirectUnauthorizedTo(state);
        }
        return true;
      }),
    );
  }

  public canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | UrlTree {
    return this.canActivate(route, state);
  }

  private _getRedirectUnauthorizedTo(state: RouterStateSnapshot): UrlTree {
    return this._router.createUrlTree(['/auth', 'sign-in'], {
      queryParams: {
        redirectUrl: state.url,
      },
    });
  }
}
